import { render, staticRenderFns } from "./Deviation.vue?vue&type=template&id=125f3d3a&"
import script from "./Deviation.vue?vue&type=script&lang=js&"
export * from "./Deviation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports